export enum LayoutMode {
  GRID = 'grid',
  LIST = 'list-large',
  LIST_NEW = 'list-new',
}
